import React from 'react'
import PropTypes from 'prop-types'

import {
  FileUploadZone, FormField, LoadingModule, Text,
} from '@campaignhub/suit-theme'

const UploadTab = (props) => {
  const {
    assetTypeOptions, displayAllowedFileTypes, filteredFileTypes, loading, selectedAssetType,
    type, typeResolved, uppy, callbacks,
  } = props

  const { setSelectedAssetType } = callbacks

  return (
    <>
      {displayAllowedFileTypes && assetTypeOptions.length > 0 && (
        <FormField direction="column" label="Choose Type" marginTop="large" value={selectedAssetType}>
          <select value={selectedAssetType} onChange={e => setSelectedAssetType(e.target.value)}>
            {assetTypeOptions.map(({ key, label }) => (
              <option key={key} value={key}>{label}</option>
            ))}
          </select>
        </FormField>
      )}

      <LoadingModule loading={loading} boxProps={{ border: 0 }} />

      {!loading && uppy && filteredFileTypes.length > 0 && (type !== 'Assets' || typeResolved) && (
        <FormField direction="column" marginTop="large">
          <FileUploadZone
            uppy={uppy}
            subTitle="Max Size is 2 GB"
          />
        </FormField>
      )}
      {!uppy && (
        <FormField direction="column" marginTop="large">
          <Text marginBottom="small" fontSize="xsmall">
            Could not load uppy service
          </Text>
        </FormField>
      )}
    </>
  )
}

UploadTab.propTypes = {
  assetTypeOptions: PropTypes.array,
  callbacks: PropTypes.object.isRequired,
  displayAllowedFileTypes: PropTypes.bool,
  filteredFileTypes: PropTypes.array,
  loading: PropTypes.bool,
  selectedAssetType: PropTypes.string,
  type: PropTypes.string,
  typeResolved: PropTypes.bool,
  uppy: PropTypes.object,
}

export default UploadTab
